import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MovieGLightbox } from "../../common/image_gallery.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// paginazione e galleria
	const gallery_data = document.querySelector("#_gallery-section");
	if (gallery_data) {
		let url = `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`;
		if (gallery_data.dataset.qs) {
			url = `${url}?${gallery_data.dataset.qs}`;
		}
		const main_gallery = new MovieGLightbox({
			url: url,
			per_page: 20,
			selector: gallery_data.dataset.gallerySelector,
		});

		if (gallery_data.dataset.galleryAlbum) {
			for (const el of document.querySelectorAll(
				gallery_data.dataset.galleryAlbum,
			)) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					let album_url = `/misc/immagini/${el.dataset.ct}/${el.dataset.id}/`;
					if (el.dataset.qs) {
						album_url = `${album_url}?${el.dataset.qs}`;
					}
					new MovieGLightbox({ url: album_url });
				});
			}
		}

		endlessPaginate({
			onCompleted: (context, fragment) => {
				const endless_url = new URL(context.url, window.location.origin);
				const qs = endless_url.searchParams;
				const page = Number.parseInt(qs.get(context.key));
				main_gallery.fetchPage(page);
			},
		});
	}

	// gallery video
	const video_gallery = document.querySelector("#_video-gallery");
	if (video_gallery) {
		for (const el of document.querySelectorAll("._video-album")) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				for (const album of document.querySelectorAll("._video-album")) {
					album.classList.remove("active");
				}
				const target = event.currentTarget;
				target.classList.add("active");
				fetch(`${window.location.pathname}${target.dataset.album}/`, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
				})
					.then((response) => response.text())
					.then((data) => {
						if (data) {
							video_gallery.innerHTML = data;
							scroll({
								top: video_gallery.offsetTop - 100,
								behavior: "smooth",
							});
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			});
		}
	}
});
